export default class ShortMessage {
  /* eslint-disable class-methods-use-this */
  _show(mtype, mtitle, mtext, maction, mcall) {
    this._parseInput(mtype, mtitle, mtext, maction, mcall);
    // console.log('shortMessage.showMsg()');
    const $msgContainer = $('#message-box');
    $msgContainer.find('p:first-child').html(this.msgTitle);
    $msgContainer.find('p:last-child').html(this.msgText);
    $msgContainer.addClass(`alert-${this.msgClass}`);
    $msgContainer.slideDown();
    setTimeout(() => {
      $msgContainer.slideUp();
      $msgContainer.removeClass(`alert-${this.msgClass}`);
      $msgContainer.find('p:first-child').html('');
      $msgContainer.find('p:last-child').html('');
    }, 4000);
  }

  _parseInput(mtype, mtitle, mtext, maction, mcall) {
    // console.log(mtype);
    // console.log(mtitle);
    // console.log(mtext);
    // console.log(maction);
    // console.log(mcall);
    switch (mtype) {
      case 'e':
      case 'error':
        this.msgClass = 'danger';
        break;
      case 'i':
      case 'info':
        this.msgClass = 'success';
        break;
      default:
        this.msgClass = 'default';
    }
    // console.log('----------------------');
    // console.log(this.msgClass);
    // console.log('----------------------');
    if (mtitle !== undefined || mtitle !== '') {
      this.msgTitle = mtitle;
    } else {
      this.msgTitle = 'Info';
    }
    if (mtext !== undefined || mtext !== '') {
      this.msgText = mtext;
    } else {
      this.msgText = '';
    }
    if (maction !== undefined || maction !== '') {
      this.msgAction = maction;
    } else {
      this.msgAction = '';
    }
    if (mcall !== undefined || mcall !== '') {
      this.msgCallback = maction;
    } else {
      this.msgCallback = '';
    }
  }
  /* eslint-enable class-methods-use-this */
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/short_message.js